export default __webpack_public_path__ + "static/media/08-FiligreeDonut.57388e72.png";